import kurdish from "../../../shared/assets/flag.png";
import iraq from "../../../shared/assets/iraq.png";
import { Select } from "antd";
import i18n from "../../../i18";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";

export const LANGUAGES = [
  { value: "ku", label: "کوردی",   flag: kurdish },
  { value: "ar", label: "العربية", flag: iraq },
  { value: "en", label: "English", flag: null },
  { value: "tr", label: "Türkçe",  flag: null },
];

const Language = () => {
  const [language, setLanguage] = useState("en");

  const onChangeLang = (lang) => {
    setLanguage(lang);
    // Centralized in i18.js: waits for locale JSON, updates dir + strings together.
    i18n.changeLanguage(lang);
  };

  useEffect(() => {
    const saved = i18n.normalizeLang(
      Cookies.get("language") || localStorage.getItem("selectedLanguage") || "en"
    );
    setLanguage(saved);
    if (saved !== i18n.normalizeLang(i18n.i18n.language)) {
      i18n.changeLanguage(saved);
    }
  }, []);

  return (
    <Select value={language} onChange={onChangeLang} style={{ minWidth: 130 }} optionLabelProp="label">
      {LANGUAGES.map((lang) => (
        <Select.Option key={lang.value} value={lang.value} label={
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {lang.flag
              ? <img src={lang.flag} alt={lang.label} width={18} height={18} style={{ borderRadius: 2 }} />
              : <span style={{ fontSize: 15 }}>🌐</span>}
            {lang.label}
          </span>
        }>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {lang.flag
              ? <img src={lang.flag} alt={lang.label} width={20} height={20} style={{ borderRadius: 2 }} />
              : <span style={{ fontSize: 16 }}>🌐</span>}
            {lang.label}
          </span>
        </Select.Option>
      ))}
    </Select>
  );
};

export default Language;
